import { IoSearchOutline } from "react-icons/io5";
import './index.css'

const Navbar = () => (
    <div className='navbar-container'>
        <div className="nav-1">
            <p className="para-1">Payments</p>
            <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704782091/icon-13_xgqika.svg" className="image-1" />
            <span className="span">How it works</span>
        </div>
        <div className='search-bar'>
            <IoSearchOutline />
            <input type="search" placeholder="Search features,tutorials, etc." className="search-input" />
        </div>
        <div className="icon-container">
            <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704782092/icon-14_xzktvu.svg" className="image-2" />
            <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704782092/icon-15_hthz4r.svg" className="image-2" />
        </div>
    </div>
)

export default Navbar